import { UserAbridged } from "../abridged/user-abridged.model";
import { TrainingCourseSection } from "./training-course-section.model";
import { TrainingType } from "./training-type";

export class TrainingCourse {
  trainingId: number;
  trainingName: string;
  description: string;
  validForMonths: number;
  type: TrainingType;
  sections: TrainingCourseSection[] = [];
  sites: string[] = [];
  siteIds: string[] = [];
  siteOwner: UserAbridged;

  public deserialize(input: any): this {
    this.trainingId = input.id;
    this.trainingName = input.name;
    this.description = input.description;
    this.validForMonths = input.validForMonths;

    this.siteOwner = (new UserAbridged()).deserialize(input.siteOwner);

    this.type = input.courseType;

    this.sites = input.sites.map(site => site.name).sort((a, b) => a.localeCompare(b));
    this.siteIds = input.sites.map(site => site.id);

    this.sections = input.courseSections
      .filter(section => !section.deleted)
      .sort((a, b) => a.sectionOrder - b.sectionOrder)
      .map((section, index) => (new TrainingCourseSection()).deserialize(section, index))
      .sort(TrainingCourseSection.sort);

      for (let i = 0; i < this.sections.length; i++) {
      if (i === this.sections.length - 1) {
        this.sections[i].setIsLastSection();
      } else {
        this.sections[i].setNextSectionId(this.sections[i + 1].courseSectionId);
      }
    }

    return this;
  }

  public getSectionById(sectionId): TrainingCourseSection {
    return this.sections.find(section => section.courseSectionId === sectionId);
  }
};
